import ExcelJS from "exceljs";

export function convertToCSV(objArray) {
  const array = typeof objArray === "string" ? JSON.parse(objArray) : objArray;
  if (!Array.isArray(array) || array.length === 0) return "";

  // build header row
  const headers = Object.keys(array[0]);
  const escape = (val) => {
    let s = val == null ? "" : String(val);
    if (s.includes('"')) s = s.replace(/"/g, '""');
    return `"${s}"`;
  };

  let csv = headers.map(escape).join(",") + "\r\n";

  // build data rows
  array.forEach((row) => {
    const line = headers.map((key) => escape(row[key])).join(",");
    csv += line + "\r\n";
  });

  return csv;
}

// export function exportGrossVsDiscountCSV({
//   objects,
//   selectedYear,
//   selectedStoreCode,
//   fileNamePrefix = "DiscountGross",
// }) {
//   // 1) aggregate data
//   const aggregated = {};
//   objects
//     .filter((o) => o.status === "C")
//     .forEach((sale) => {
//       const d = new Date(sale.tran_date);
//       const year = d.getFullYear();
//       const month = d.toLocaleString("default", { month: "long" });
//       const store = sale.store_code.replace("ANGELSPIZZA_", "");

//       if (selectedYear && year !== parseInt(selectedYear, 10)) return;
//       if (selectedStoreCode && store !== selectedStoreCode) return;

//       const key = `${month} ${year}`;
//       const total = Number(sale.total || 0);
//       const discount = Number(sale.discount_amount || 0);

//       if (!aggregated[key]) {
//         aggregated[key] = {
//           Brand: "Angels Pizza",
//           Store: store,
//           Month: month,
//           Year: year,
//           "Gross Sales": total,
//           "Discount Amount": discount,
//         };
//       } else {
//         aggregated[key]["Gross Sales"] += total;
//         aggregated[key]["Discount Amount"] += discount;
//       }
//     });

//   // 2) convert to array and CSV
//   const rows = Object.values(aggregated);
//   const csvArray = rows.length ? rows : [];
//   const csv = convertToCSV(csvArray);

//   if (!csv) {
//     console.error("exportGrossVsDiscountCSV: nothing to export");
//     return;
//   }

//   // 3) trigger download
//   const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
//   const link = document.createElement("a");
//   const name = `${fileNamePrefix}_${selectedYear || ""}.csv`;
//   link.href = URL.createObjectURL(blob);
//   link.download = name;
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// }

export async function exportGrossVsDiscountCSV({
  objects,
  selectedYear,
  selectedStoreCode,
  fileNamePrefix = "DiscountGross",
}) {
  // ===== 1) Aggregate data =====
  const aggregated = {};

  (objects || [])
    .filter((o) => o.status === "C")
    .forEach((sale) => {
      const d = new Date(sale.tran_date);
      const year = d.getFullYear();
      const month = d.toLocaleString("default", { month: "long" });
      const store = sale.store_code?.replace("ANGELSPIZZA_", "") || "Unknown";

      if (selectedYear && year !== Number(selectedYear)) return;
      if (selectedStoreCode && store !== selectedStoreCode) return;

      const key = `${month} ${year}`;
      const gross = Number(sale.total || 0);
      const discount = Number(sale.discount_amount || 0);

      if (!aggregated[key]) {
        aggregated[key] = {
          Brand: "Angels Pizza",
          Store: store,
          Period: key,
          GrossSales: gross,
          DiscountAmount: discount,
        };
      } else {
        aggregated[key].GrossSales += gross;
        aggregated[key].DiscountAmount += discount;
      }
    });

  const rows = Object.values(aggregated);

  if (!rows.length) {
    console.warn("exportGrossVsDiscountXLSX: nothing to export");
    return;
  }

  // Compute Net Sales
  rows.forEach((r) => {
    r.NetSales = r.GrossSales - r.DiscountAmount;
  });

  // Totals
  const totals = rows.reduce(
    (acc, r) => {
      acc.GrossSales += r.GrossSales;
      acc.DiscountAmount += r.DiscountAmount;
      acc.NetSales += r.NetSales;
      return acc;
    },
    { GrossSales: 0, DiscountAmount: 0, NetSales: 0 },
  );

  // ===== 2) Workbook =====
  const workbook = new ExcelJS.Workbook();
  workbook.creator = "Analytics Export";
  workbook.created = new Date();

  const sheet = workbook.addWorksheet("Gross vs Discount", {
    views: [{ state: "frozen", ySplit: 4 }],
  });

  // ===== Title =====
  sheet.mergeCells("A1:F1");
  const titleCell = sheet.getCell("A1");
  titleCell.value = "Gross Sales vs. Discount Value";
  titleCell.font = { bold: true, size: 16, color: { argb: "FFFFFFFF" } };
  titleCell.alignment = { vertical: "middle", horizontal: "left" };
  titleCell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FF1F2937" },
  };
  sheet.getRow(1).height = 26;

  // ===== Meta =====
  sheet.mergeCells("A2:F2");
  const metaCell = sheet.getCell("A2");
  metaCell.value = `Brand: Angels Pizza   |   Store: ${
    selectedStoreCode || "All Stores"
  }   |   Year: ${selectedYear || "All Years"}`;
  metaCell.font = { italic: true, size: 11, color: { argb: "FF111827" } };
  metaCell.alignment = { vertical: "middle", horizontal: "left" };
  metaCell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFF3F4F6" },
  };
  sheet.getRow(2).height = 18;

  // Spacer
  sheet.addRow([]);
  sheet.getRow(3).height = 6;

  // ===== Header =====
  const headers = [
    "Brand",
    "Store",
    "Period",
    "Gross Sales",
    "Discount Amount",
    "Net Sales",
  ];
  sheet.addRow(headers);

  // ===== Data rows =====
  rows.forEach((r) => {
    sheet.addRow([
      r.Brand,
      r.Store,
      r.Period,
      r.GrossSales,
      r.DiscountAmount,
      r.NetSales,
    ]);
  });

  // Column widths
  sheet.columns = [
    { width: 16 },
    { width: 18 },
    { width: 18 },
    { width: 18 },
    { width: 20 },
    { width: 18 },
  ];

  const headerRowIndex = 4;
  const firstDataRow = headerRowIndex + 1;
  const lastDataRow = headerRowIndex + rows.length;

  // Header styling
  const headerRow = sheet.getRow(headerRowIndex);
  headerRow.height = 18;
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true,
    };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF2563EB" },
    };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // Body styling
  for (let r = firstDataRow; r <= lastDataRow; r++) {
    const row = sheet.getRow(r);
    const isAlt = (r - firstDataRow) % 2 === 1;

    row.eachCell((cell, col) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      if (col <= 3) {
        cell.alignment = { vertical: "middle", horizontal: "left" };
      } else {
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.numFmt = '"₱"#,##0.00';
      }

      if (isAlt) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFF9FAFB" },
        };
      }
    });
  }

  // ===== TOTAL row =====
  const totalRowIndex = lastDataRow + 1;
  sheet.mergeCells(`A${totalRowIndex}:C${totalRowIndex}`);

  const totalLabel = sheet.getCell(`A${totalRowIndex}`);
  totalLabel.value = "TOTAL";
  totalLabel.font = { bold: true };
  totalLabel.alignment = { vertical: "middle", horizontal: "left" };
  totalLabel.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: { argb: "FFEFF6FF" },
  };

  const totalValues = [
    totals.GrossSales,
    totals.DiscountAmount,
    totals.NetSales,
  ];

  for (let i = 0; i < totalValues.length; i++) {
    const cell = sheet.getCell(totalRowIndex, 4 + i); // D, E, F
    cell.value = totalValues[i];
    cell.font = { bold: true };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.numFmt = '"₱"#,##0.00';
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFEFF6FF" },
    };
  }

  // Auto-filter
  sheet.autoFilter = {
    from: { row: headerRowIndex, column: 1 },
    to: { row: headerRowIndex, column: headers.length },
  };

  // ===== Download =====
  const safeName = `${fileNamePrefix}_${selectedYear || "AllYears"}.xlsx`;

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = safeName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => URL.revokeObjectURL(link.href), 500);
}
